let headerHeight = 100;
let mobileHeaderHeight = 100;
const header = document.querySelector('.navbar-holder');
const fakeHeader = document.querySelector('.fake-nav-bar');

const mobileHeader = document.querySelector('.mobile-header');
const mobileFakeHeader = document.querySelector('.mobile-fake-nav');

export default function initNavigationBarSticky() {
    if (header && mobileHeader) {
        headerHeight = header.clientHeight;
        mobileHeaderHeight = mobileHeader.clientHeight;

        fakeHeader.style.height = headerHeight + 'px';
        mobileFakeHeader.style.height = mobileHeaderHeight + 'px';
        bindStickyCheck();
    }

    document.addEventListener('scroll', bindStickyCheck);
}

function bindStickyCheck() {
    if (header && mobileHeader) {
        if (window.pageYOffset > headerHeight - 100) {
            header.classList.add('sticky');
            fakeHeader.classList.remove('d-none');
        } else {
            header.classList.remove('sticky');
            fakeHeader.classList.add('d-none');
        }

        if (window.pageYOffset > mobileHeaderHeight - 100) {
            mobileHeader.classList.add('sticky');
            mobileFakeHeader.classList.remove('d-none');
        } else {
            mobileHeader.classList.remove('sticky');
            mobileFakeHeader.classList.add('d-none');
        }
    }
}
